import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppStore } from '@store/appStore';
import TrustScoreDetailsContent from '../components/TrustScoreDetailsContent';

const TrustScoreDetailsPage = () => {
  const { aircraftId } = useParams();
  const { setPageHeaderOverride, clearPageHeaderOverride } = useAppStore();

  // AppLayout renders the shared page header (title + back button) on
  // the sky-blue background above the white content card. Sub-pages
  // signal into it via setPageHeaderOverride — matches the pattern
  // AdditionalServicesInvoicePage / other sub-pages use, so title
  // placement + typography match the rest of the app automatically.
  useEffect(() => {
    setPageHeaderOverride({ title: 'TrustScore' });
    return () => clearPageHeaderOverride();
  }, [setPageHeaderOverride, clearPageHeaderOverride]);

  return (
    // Standard sub-page wrapper — same translucent rounded card the
    // /tails / QuotesList / AdditionalServicesInvoicePage use. Title +
    // back button live in AppLayout's shared header (fed by
    // setPageHeaderOverride above).
    <div className="pb-24 w-full bg-white/50 backdrop-blur-sm rounded-[2rem] p-4 md:p-6">
      <TrustScoreDetailsContent aircraftId={aircraftId} />
    </div>
  );
};

export default TrustScoreDetailsPage;
